export default '/build/1a242825.png'